import type { ButtonDropdownItem } from '@factorialco/f0-react'
import { Check, CheckCircle, CheckDouble } from '@factorialco/f0-react/icons/app'
import type { ProcurementValueObjectsPurchaseOrderStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const STATUS_ICON_MAP = {
  check: Check,
  checkDouble: CheckDouble,
  checkCircle: CheckCircle,
}

const VALID_PO_STATUSES: ProcurementValueObjectsPurchaseOrderStatusEnum[] = [
  'processing',
  'draft',
  'pending',
  'ordered',
  'partial',
  'received',
  'closed',
]

export function isValidStatus(
  value: string
): value is ProcurementValueObjectsPurchaseOrderStatusEnum {
  return VALID_PO_STATUSES.some((s) => s === value)
}

function getPrimaryAction(
  currentStatus: ProcurementValueObjectsPurchaseOrderStatusEnum
): ButtonDropdownItem<ProcurementValueObjectsPurchaseOrderStatusEnum> {
  if (currentStatus === 'pending') {
    return {
      value: 'ordered',
      label: i18n.t('procurement.purchase_orders.actions.mark_ordered'),
      icon: STATUS_ICON_MAP.check,
    }
  }
  // ordered or partial
  return {
    value: 'received',
    label: i18n.t('procurement.purchase_orders.actions.mark_received'),
    icon: STATUS_ICON_MAP.checkDouble,
  }
}

export function getDropdownItems(
  currentStatus: ProcurementValueObjectsPurchaseOrderStatusEnum
): ButtonDropdownItem<ProcurementValueObjectsPurchaseOrderStatusEnum>[] {
  const primary = getPrimaryAction(currentStatus)
  const items: ButtonDropdownItem<ProcurementValueObjectsPurchaseOrderStatusEnum>[] = [primary]

  if (currentStatus === 'ordered') {
    items.push({
      value: 'partial',
      label: i18n.t('procurement.purchase_orders.actions.mark_received_partial'),
      icon: STATUS_ICON_MAP.check,
    })
  }

  items.push({
    value: 'closed',
    label: i18n.t('procurement.purchase_orders.actions.close'),
    icon: STATUS_ICON_MAP.checkCircle,
  })

  return items
}

export function getSuccessMessage(value: ProcurementValueObjectsPurchaseOrderStatusEnum): string {
  const messageMap: Record<string, string> = {
    ordered: i18n.t('procurement.purchase_orders.responses.ordered.success'),
    received: i18n.t('procurement.purchase_orders.responses.received.success'),
    partial: i18n.t('procurement.purchase_orders.responses.received_partial.success'),
    closed: i18n.t('procurement.purchase_orders.responses.closed.success'),
    pending: i18n.t('procurement.purchase_orders.responses.reopened.success'),
  }
  return messageMap[value] ?? ''
}
